var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section-title',{staticClass:"mb-6 mb-md-12",attrs:{"title":_vm.mainFields.title_sites,"browse-title":_vm.mainFields.browse_all_sites,"browse-link":{ name: 'Sites', params: { biennale: _vm.biennale } }}}),_vm._v(" "),_c('sites-list',{attrs:{"list":_vm.sectionData.children,"biennale":_vm.biennale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }